/**
 * Format a numeric amount using the store's currency settings.
 * Falls back gracefully if settings are missing.
 */
export function formatMoney(amount, settings) {
  const symbol = settings?.currencySymbol ?? '£';
  const value = Number.isFinite(amount) ? amount : 0;
  return `${symbol}${value.toFixed(2)}`;
}

/** Compute order totals consistently across cart / checkout / confirmation. */
export function computeTotals(items, settings) {
  const s = settings || {};
  const subtotal = items.reduce((sum, it) => sum + it.price * (it.qty || 1), 0);

  const freeThreshold = s.freeShippingThreshold ?? 75;
  const flat = s.shippingFlatRate ?? 8.99;
  const shipping = items.length === 0 || subtotal >= freeThreshold ? 0 : flat;

  const taxRate = (s.taxRatePercent ?? 0) / 100;
  const tax = s.taxInclusive ? 0 : +(subtotal * taxRate).toFixed(2);

  const total = +(subtotal + shipping + tax).toFixed(2);
  return { subtotal: +subtotal.toFixed(2), shipping, tax, total, taxRate };
}
